import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import { Button, Field, CellGroup, NavBar, List, Cell, Dialog, Form, Loading, Tabbar, TabbarItem, Icon, Tag, Empty, Progress, Alert } from 'vant'
import 'vant/lib/index.css'

const app = createApp(App)

app.use(Button)
app.use(Field)
app.use(CellGroup)
app.use(NavBar)
app.use(List)
app.use(Cell)
app.use(Dialog)
app.use(Form)
app.use(Loading)
app.use(Tabbar)
app.use(TabbarItem)
app.use(Icon)
app.use(Tag)
app.use(Empty)
app.use(Progress)
app.use(Alert)

app.use(router)
app.mount('#app')
